import React,{useState,useEffect} from 'react';
import { Link, useParams  } from 'react-router-dom';
import axios from 'axios';
import config from '../config';
import { useNavigate } from "react-router-dom";
import Popover from '../admin/shared/Popover';
import SucessMessage from './shared/SucessMessage';
import { StoreModel } from '../common/constants';

function AddLocation() {
  const navigate = useNavigate();
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedPopoverId, setSelectedPopoverId] = useState(null);
  const [formData,setFormData] = useState({
        location:"",
    });
  const [errors,setErrors] = useState({
    location: '',
  });

const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission here
    console.log('Form submitted');
    if (!formData.location) {
      setErrors({
        ...errors,
        location: 'Please enter a location name',
      });
      return;
    }
    try {
      const  dataToSend = {
          name: formData.location,
        };
      axios.post(`${config.backendUrl}/admin/locations/store`, dataToSend, {
        headers: {
          'token': localStorage.getItem('token'), // Example authorization header
          'Content-Type': 'application/json', // Example content type header
          // Add more headers as needed
        }
      });
      // Handle success
      setSelectedPopoverId(true);
    } catch (error) {
      // Handle error
      console.error('Error uploading file:', error);
    }   
  };
const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleClosePopover = () => {
  
    setSelectedPopoverId(false);

    navigate("/admin/locations");
  };


  return (
    <> 
    <div className="pt-[70px]"> 
      <h2>Locations</h2>
      <div className="breadcrumbs">
        {" "}
        <Link to="/admin/dashboard">Home</Link>
          <span>{">"} </span> <Link to="/admin/locations">Locations</Link>
        <span>{">"} </span>Add Location{" "}
      </div>
      </div>

      <div className='whitebox uploadproductpop' >
      <div className="container mx-auto p-4">
      <div className="flex flexwrapcol -mx-2 lg:gap-10">
       
        {/* Column 1 */}
       
        <div className="w-full md:w-1/2 px-2 mb-4"> 
        <h2>{isEditMode ? 'Edit Location' : 'Add Location'}</h2>
        <p className='mb-3'>{isEditMode ? 'Update Location Details' : 'Add to Create Location'}</p>
        <form onSubmit={handleSubmit}>
          <div className="flex items-center mb-6">
          <label className="block text-sm   leading-5  w-1/2" htmlFor="LocationName">
            Location Name
          </label>
         <div className="block w-full "> <input name="location"  value={formData.location}  onChange={handleInputChange} className="block w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline" />
          {errors.location && <p style={{ color: 'red' }}>{errors.location}</p>}
          </div>
          </div>

          

          <div className="flex items-center mb-6">
            <label className="block text-sm   leading-5  w-1/2 "> 
            </label>
            <div  className="block w-full"> 
            <button className="redbtn" type="submit">
               Save
            </button>
          </div>
          </div>
          </form>
        </div>
     
     
      </div>
    </div>
      </div>
      {selectedPopoverId && (
          <Popover onClose={handleClosePopover}  isVisible={selectedPopoverId !== null}>
          
                    
       <SucessMessage>

          <h4>Location Added <br/> 
          Successfully</h4>
        </SucessMessage>

          </Popover>
        )}
    </ >
  )
}

export default AddLocation
